import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAKKz5MfkNprI6wDpKfqzwg_6WaQN26nAY",
  authDomain: "bookhr-7756b.firebaseapp.com",
  projectId: "bookhr-7756b",
  storageBucket: "bookhr-7756b.appspot.com",
  messagingSenderId: "615701900022",
  appId: "1:615701900022:web:37a74ad7736e8be7081ad7",
};
const app = initializeApp(firebaseConfig);

export default app;
